<template>
  <div class="contact">
    <div class="pc">
      <div class="banner">
        <div class="banner">
          <img src="img/zbj.png" alt="" />
          <div class="mask">
            <div class="box">Contact Us</div>
          </div>
        </div>
      </div>
      <div class="box">
        <h3 class="title"><span>Enq</span>uiry</h3>
        <p>
          lf you have any enquiries, you can contact customer service via email
          to learn about the company's products and <br />
          services and request a quotation
        </p>
      </div>
      <div class="module1">
        <div class="box">
          <div class="top">
            <div class="demo-input-suffix">
              <el-input
                class="textarea"
                placeholder="Contact Person"
                v-model="input1"
                clearable
                size="medium"
              >
              </el-input>
            </div>
            <div class="demo-input-suffix">
              <el-input placeholder="Company Name" v-model="input2" clearable>
              </el-input>
            </div>
            <div class="demo-input-suffix">
              <el-input placeholder="Email" v-model="input3" clearable>
              </el-input>
            </div>
            <div class="demo-input-suffix">
              <el-input placeholder="Tel.no" v-model="input4" clearable>
              </el-input>
            </div>
          </div>
          <div class="bottom">
            <el-input
              type="textarea"
              :rows="12"
              placeholder="Message"
              v-model="textarea"
            >
            </el-input>
          </div>
          <div class="btn3" @click="this.submit">send</div>
        </div>
      </div>
      <div class="module2">
        <div class="content">
          <div>
            <div class="left"><img src="img/d1.png" alt="" /></div>
            <div class="right">
              <h3 class="title"><span>Hon</span>g Kong</h3>
              <p>Flat B&C,11/F Winner Factory Building,</p>
              <p>55 Hung to Road, Kwun Tong</p>
              <p>Kowloon, Hong Kong</p>
              <p>TEL (852)2343 3650</p>
              <p>FAX (852)2341 1597,2344 7465</p>
              <p>EMAIL info@kenta.com.cn</p>
            </div>
          </div>
          <div>
            <div class="left"><img src="img/d2.png" alt="" /></div>
            <div class="right">
              <h3 class="title"><span>Dong</span>guan</h3>
              <p>He Xi District,Jin Xia, Cheung On,</p>
              <p>Dongguan City,</p>
              <p>Guangdong China</p>
              <p>TEL (+86 0769)8553 3429,8531 7199</p>
              <p>FAX (+86 0769)8553 6899,8553 6999</p>
              <p>EMAIL info@kenta.com.cn</p>
            </div>
          </div>
          <div>
            <div class="left"><img src="img/d3.png" alt="" /></div>
            <div class="right">
              <h3 class="title"><span>Kun</span>shan</h3>
              <P>888 Xinmao Road,</P>
              <P>zhoushi Town, Kunshan City,</P>
              <P>Jiangsu China</P>
              <p>TEL (+86 0512) 5788 9889</p>
              <p>FAX (+86 0512) 5788 9999</p>
              <p>EMAIL info@kenta.com.cn</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      textarea: "",
    };
  },
  methods: {
    submit() {
      alert("发送成功!");
    },
  },
};
</script>
<style >
.el-input__inner {
  height: 60px !important;
  font-size: 1.5vw !important;
}
.el-textarea__inner {
  font-size: 1.5vw !important;
}
</style>
<style lang="less" scoped>
.pc {
  .banner {
    height: 29vw;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      width: 120%;
      position: relative;
      top: -15vw;
      left: -15vw;
      z-index: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      background: rgba(15, 15, 15, 0.301);
      width: 100%;
      height: 100%;
      .box {
        position: absolute;
        bottom: 0;
        width: 50%;
        height: 15%;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        color: white;
        font-size: 4vw;
        font-weight: 800;
      }
    }
  }

  .box {
    width: 70%;
    margin: 1vw auto;
    h3 {
      font-size: 2vw;
      margin: 3vw 0;
      span {
        border-bottom: red solid 0.2vw;
        padding: 1vw 0;
      }
    }
    > p {
      color: gray;
      font-size: 1.2vw;
    }
  }

  .module1 {
    .box {
      width: 70%;
      margin: 0 auto;
      .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .demo-input-suffix {
          width: 49%;
          margin-top: 1vw;
          .el-input__inner {
            font-size: 1vw !important;
            height: 120px impo !important;
            line-height: 20px im !important;
          }
        }
      }
      .bottom {
        width: 100%;
        margin: 1vw 0;
      }
    }
    .btn3 {
      color: white;
      background: black;
      text-align: center;
      width: 10%;
      padding: 0.8vw 1vw;
      font-size: 1.2vw;
    }
  }
}
.module2 {
  width: 100%;
  background: white;
  padding: .8vw 0;
  .content {
    margin: 0 auto;
    width: 70%;
    > div {
      margin-top: 2vw;
      display: flex;
      justify-content: space-between;
      > div {
        width: 50%;
        box-sizing: border-box;
        p {
          color: gray;
          font-size: 1vw;
        }
      }
      .right {
        padding-left: 20%;
        line-height: 3vw;
        h3 {
          font-size: 2vw;
          span {
            padding: 1vw 0;
            border-bottom: red solid 0.2vw;
          }
          margin-bottom: 2vw;
        }
      }
    }
    img {
      width: 100%;
    }
  }
}
</style>